export const IS_SANDBOX_PAYMENTS =
  process.env.EXPO_PUBLIC_IS_SANDBOX_PAYMENTS === 'true';
export const HEAP_APP_ID = process.env.EXPO_PUBLIC_HEAP_APP_ID;
